import { useEffect, useLayoutEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import useDocumentTitle from 'hooks/useDocumentTitle';
import { useStore } from 'models/stores';

import Job from './Job';
import MainHeader from './MainHeader';
import NoAvailableJobs from './NoAvailableJobs';
import LabelText from './LabelText';

import { CONTENT_MAX_WIDTH, DIVIDER_COLOR } from '../styles/constants';

function JobList() {
  const { jobStore, uiStore } = useStore();
  const { state, jobs } = jobStore;
  const { t } = uiStore;
  const location = useLocation();
  const [scrollY, setScrollY] = useState(0);
  uiStore.clearSelectedJob();
  useDocumentTitle();

  useLayoutEffect(() => {
    if (location.state) {
      window.scrollTo(0, location.state.scrollY);
    }
  }, [location.state]);

  useEffect(() => {
    const listener = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener('scroll', listener);
    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, []);

  const openingsText =
    jobs.length === 0
      ? t('no_openings')
      : jobs.length === 1
      ? t('openings_singular', jobs.length)
      : t('openings_plural', jobs.length);

  return (
    <>
      <MainHeader>{state === 'loaded' && <LabelText>{openingsText}</LabelText>}</MainHeader>
      {state === 'loaded' && jobs.length === 0 ? (
        <NoAvailableJobs />
      ) : (
        <JobListContainer>
          {jobs.map((job, i) => (
            <Link to={`${job.id}${location.search}`} state={{ scrollY: scrollY }} key={job.id}>
              <Job data={job} />
              {i < jobs.length - 1 && (
                <JobEntrySeparator>
                  <div />
                </JobEntrySeparator>
              )}
            </Link>
          ))}
        </JobListContainer>
      )}
    </>
  );
}
export default observer(JobList);

const JobEntrySeparator = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;

  > div {
    height: 1px;
    width: 100%;
    max-width: ${CONTENT_MAX_WIDTH};
    margin: 0 auto;
    background-color: ${DIVIDER_COLOR};

    @media (max-width: 1080px) {
      margin: 0 24px;
    }
  }
`;

const JobListContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;
